module.exports = __webpack_public_path__ + "img/mastercard.f18574dd.png";